import { AddAPhoto } from "@mui/icons-material";
import {
  Avatar,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import React, { useRef, useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import logo from "./logo.png";
import { httpService } from "../httpService";
import { AlertContext } from "../contexts/AlertContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { storage } from "../firebase";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { Badge, Modal, ProgressBar } from "react-bootstrap";
import { LoadingButton } from "@mui/lab";
import {
  faCalendar,
  faClock,
  faHouse,
  faUser,
  faFileUpload,
} from "@fortawesome/free-solid-svg-icons";
import QRCode from "react-qr-code";
import imageCompression from "browser-image-compression";
import { eventBio } from "./info";

export default function PrintOut() {
  const { id } = useParams();

  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(false);
  const componentRef = useRef();
  const [show, setShow] = useState(false);
  const [file, setFile] = useState(null);
  const [image, setImage] = useState(null);
  const [participant, setParticipant] = useState({});
  const [updating, setUpdating] = useState(false);

  const [progress, setProgress] = useState(0);

  const { setAlertData } = useContext(AlertContext);

  const getData = async () => {
    setLoading(true);
    const { data, error } = await httpService(`viewprintout/${id}`);

    if (data) {
      setParticipants(data);
    }
    if (error) {
      setAlertData({
        open: true,
        message: error,
        severity: "error",
      });
    }
    setLoading(false);
  };
  const toggle = () => setShow(!show);

  const handleChange = (e) => {
    if (e.target.files[0].size > 1_000_000)
      return setAlertData({
        message: "Please select an image less than or equal to 1MB.",
        open: true,
        severity: "error",
      });
    setFile(e.target.files[0]);

    setImage(URL.createObjectURL(e.target.files[0]));
  };

  const clearImage = () => {
    setFile(null);
    setImage(null);
  };

  const uploadImage = async (c) => {
    if (!file) return;
    setUpdating(true);

    const extension = file.type.split("/").pop();
    const newFileName = `${c.code}.${extension}`;

    const storageRef = ref(storage, `/policymeeting/${newFileName}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const prog = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );

        setProgress(prog);
      },
      (err) => {
        setAlertData({ open: true, message: err.message, severity: "error" });
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (url) => {
          const imageURL = url;

          const { data, error } = await httpService.patch(
            `uploadimage/${c._id}`,
            { imageURL }
          );

          if (data) {
            window.location.reload();
          }

          if (error) {
            setAlertData({
              open: true,
              message: error,
              severity: "error",
            });
          }
        });
      }
    );

    setUpdating(false);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      <div className="mt-5 mb-5 p-3">
        <div ref={componentRef} className="p-3">
          <div className="text-center">
            <Stack>
              <div>
                <img src={logo} width="120" height="100" alt="logo" />
              </div>
              <div>
                <div className="">
                  <div className="mt-2">
                    <Typography fontSize={28} fontWeight={700}>
                      JOINT ADMISSIONS & MATRICULATION BOARD
                    </Typography>
                    <Typography variant="h6" textTransform={"uppercase"}>
                      Registration for 2024 POLICY MEETING & 4<sup>th</sup>{" "}
                      Edition of NATAP-M Awards
                    </Typography>
                  </div>
                </div>
                {loading && <CircularProgress />}
                {/* <div className="d-sm-block d-md-none">
                  <div className="mt-2">
                    <Typography variant="h6" fontWeight={700}>
                      JOINT ADMISSIONS & MATRICULATION BOARD
                    </Typography>
                    <Typography textTransform={"uppercase"} fontWeight={500}>
                      Registration for JAMB POLICY MEETING 2023
                    </Typography>
                  </div>
                </div> */}
              </div>
            </Stack>
          </div>
          {participants.map((c, i) => (
            <div key={i}>
              <div className="text-end">
                <Typography variant="h5" fontWeight={700} color={"#c2c2c2"}>
                  Participant {c.roleCategory}
                </Typography>
              </div>
              {c.status !== "complete" && (
                <div className="col-lg-4">
                  <div className="alert alert-warning">
                    <p>
                      Your registration is incomplete. Kindly upload an image of
                      yourself to complete the registration.
                    </p>
                  </div>
                </div>
              )}
              <div className="d-flex justify-content-between p-2">
                <div className="col-lg-4">
                  <div className="mt-1">
                    <div className="mb-3">
                      <Typography gutterBottom>
                        Registration ID: <strong>{c.code}</strong>
                      </Typography>
                      <Typography gutterBottom>
                        Role: <strong>{c.role}</strong>
                      </Typography>
                    </div>
                    <div className="mb-3">
                      <Stack direction="row" spacing={1}>
                        <Typography variant="body1">
                          Name:{" "}
                          <strong>
                            {c.title} {c.firstName} {c.lastName}
                          </strong>
                        </Typography>
                      </Stack>
                    </div>
                    <div className="mb-3">
                      <Typography variant="body1">
                        Institution: <strong>{c.institution}</strong>
                      </Typography>

                      <Typography>
                        State: <strong>{c.state}</strong>
                      </Typography>
                    </div>
                    <div className="mb-3">
                      <Typography variant="body2" fontWeight={400}>
                        Email: {c.emailAddress}
                      </Typography>
                      <Typography variant="body2" fontWeight={400}>
                        Phone Number: +{c.phoneNumber}
                      </Typography>
                    </div>
                    <div className="mb-3">
                      <Typography variant="body2" fontWeight={400}>
                        <strong>{c.trainingDate}</strong>
                      </Typography>
                    </div>
                    <div className="mb-3">
                      {c.status === "complete" ? (
                        <Badge bg="success">{c.status}</Badge>
                      ) : (
                        <Badge bg="warning">{c.status}</Badge>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <QRCode
                    size={200}
                    value={`https://jambpolicymeeting.web.app/attendance/${c._id}`}
                  />
                </div>
                <div className="col-lg-3">
                  {c.imageURL ? (
                    <img
                      height={240}
                      width={240}
                      className="object-fit-fill "
                      //className="img-thumbnail"
                      src={c.imageURL}
                      alt={c.code}
                    />
                  ) : (
                    <div>
                      <Avatar
                        variant="rounded"
                        sx={{ height: 200, width: 220 }}
                      >
                        <FontAwesomeIcon icon={faUser} />
                      </Avatar>
                      <div className="mt-2">
                        <Button
                          endIcon={<AddAPhoto />}
                          onClick={() => {
                            setParticipant(c);
                            setShow(true);
                          }}
                        >
                          Upload image
                        </Button>
                        <div>
                          <Typography variant="caption">
                            Image should not be more than 1 MB
                          </Typography>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
          <div
            className="mt-3 rounded shadow-sm p-3"
            style={{ backgroundColor: "#c2d8d7", color: "#41585c" }}
          >
            <div className="mb-1">
              <Stack direction="row" spacing={2}>
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faHouse} />
                </div>
                <div>
                  <Typography fontSize={16}>{eventBio.venue}</Typography>
                </div>
              </Stack>
            </div>
            <div className="mb-1">
              <Stack direction="row" spacing={2}>
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faCalendar} />
                </div>
                <div>
                  <Typography fontSize={16}>{eventBio.date}</Typography>
                </div>
              </Stack>
            </div>
            <div className="mb-1">
              <Stack direction="row" spacing={2}>
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faClock} />
                </div>
                <div>
                  <Typography fontSize={16}>9:00 AM</Typography>
                </div>
              </Stack>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <div>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button
                    // disabled={
                    //   !participants.every((c) => c.status === "complete")
                    // }
                    variant="contained"
                  >
                    {" "}
                    print slip
                  </Button>
                );
              }}
              content={() => componentRef.current}
            />
          </div>
        </div>
      </div>

      <Modal centered size="xl" backdrop="static" show={show} onHide={toggle}>
        <Modal.Header closeButton>
          {participant.firstName}'s profile
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2"></div>
          <div className="row">
            <div className="col-lg-6">
              <div class="mb-3">
                <label for="formFile" class="form-label">
                  Select an image file
                </label>
                <input
                  class="form-control"
                  type="file"
                  id="formFile"
                  accept="image/png, image/gif, image/jpeg"
                  onChange={handleChange}
                />
              </div>
              {progress > 0 && (
                <ProgressBar now={progress} label={`${progress}%`} />
              )}
            </div>
            <div className="col-lg-6">
              {image && (
                <div>
                  <img src={image} alt="question" className="img-thumbnail" />
                  <div className="mt-3">
                    <LoadingButton
                      endIcon={<FontAwesomeIcon icon={faFileUpload} />}
                      color="success"
                      onClick={() => uploadImage(participant)}
                      variant="contained"
                      loading={updating}
                      loadingPosition="end"
                    >
                      Upload image
                    </LoadingButton>
                    <Button color="error" onClick={clearImage}>
                      clear
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
